// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import mock from "./../../../services/mock"

/* istanbul ignore next  */
mock.onGet('/apps/ecommerce/getCreditUser').reply(() => {
    let credit = {
        total: 10000,
        used: 7000,
        available: 3000
    }
    return [
        200,
        {
            response: credit
        }
    ]
})
export const getCreditUser = createAsyncThunk('appEcommerce/getCreditUser', async () => {
    const response = await axios.get('/apps/ecommerce/getCreditUser')
    return response.data.response
})

export const storeSlice = createSlice({
    name: 'store',
    initialState: {
        total: 0,
        data: [],
        params: {},
        allData: [],
        cart: [],
        credit: {},
        onProductsPage: false,
        actualShoppingCart: {},
        addProducts: false
    },
    reducers: {
        // updateTotalProducts: (state, action) => {
        //     if (action.payload.type === "plus") {
        //         state.total = state.total + 1
        //     } else {
        //         state.total = state.total - action.payload.item.qty
        //     }
        // },
        updateIsOnProductsPage: (state, action) => {
            if (action.payload.isOnProductPage) {
                state.onProductsPage = true
            } else {
                state.onProductsPage = false
            }
        },
        updateAddProducts: (state, action) => {
            state.addProducts = action.payload
        },
        actualShoppingCart: (state, action) => {
            state.actualShoppingCart = action.payload
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getCreditUser.fulfilled, (state, action) => {
                state.credit = action.payload
            })
    }
})

export const { updateIsOnProductsPage, actualShoppingCart, updateAddProducts } = storeSlice.actions
export default storeSlice.reducer
